// window.SiteReady(($) => {
  window.MapsReady(($) => {

    console.log('Init Block: Location Map');

    // let indexMarkerIcon = {
    //   path: google.maps.SymbolPath.CIRCLE,
    //   fillOpacity: 1,
    //   fillColor: '#000000',
    //   strokeOpacity: 1,
    //   strokeWeight: 1,
    //   strokeColor: '#000000',
    //   scale: 12
    // };

    function distance(marker1, marker2) {
      var R = 3958.8; // Radius of the Earth in miles
      var rlat1 = marker1.position.lat() * (Math.PI / 180); // Convert degrees to radians
      var rlat2 = marker2.position.lat() * (Math.PI / 180); // Convert degrees to radians
      var difflat = rlat2-rlat1; // Radian difference (latitudes)
      var difflon = (marker2.position.lng() - marker1.position.lng()) * (Math.PI / 180); // Radian difference (longitudes)

      var d = 2 * R * Math.asin(Math.sqrt(Math.sin(difflat / 2) * Math.sin(difflat / 2) + Math.cos(rlat1) * Math.cos(rlat2) * Math.sin(difflon / 2) * Math.sin(difflon / 2)));

      return d;
    }

    function setDistances(data) {
      let marker1 = data.markers[0];

      data.markers.forEach((marker) => {
        if (marker.index > 0) {
          let dist = distance(marker1, marker);

          if (dist) {
            data.$items.filter('[data-index="' + marker.index + '"]').append(' (' + dist.toFixed(1) + ' mi)');
          }
        }
      });
    }

    //

    function initMarker($marker, data) {
      let lat = $marker.data('lat');
      let lng = $marker.data('lng');
      let index = $marker.data('index');
      let iconUrl = $marker.data('icon');
      let html = $marker.html();
      let latLng = {
        lat: parseFloat(lat),
        lng: parseFloat(lng)
      };
      let marker;

      if ( typeof index == 'undefined' ) {
        marker = new google.maps.Marker({
          position: latLng,
          map: data.map,
          $marker: $marker,
          index: index,
          //icon: 'https://cogir.test/wp-content/uploads/2025/09/marker_huge.svg',
          icon: window.THEME_MAP_MARKER_LARGE,
          zIndex: 9999,
          //iconUrl: iconUrl
        });
      } else {
        marker = new google.maps.Marker({
          position: latLng,
          map: data.map,
          $marker: $marker,
          index: index,
          iconUrl: iconUrl,
          //
          //icon: indexMarkerIcon,
          icon: iconUrl,
          label: {
            color: '#ffffff00',
            fontSize: '12px',
            text: index.toString(),
          },
        });
      }

      console.log(index)

      data.markers.push(marker);

      if (html) {
        let infowindow = new google.maps.InfoWindow({
          content: '<div class="community_poi_map_infowindow">' + html + '</div>',
          headerContent: $marker.find('h3')[0],
        });

        google.maps.event.addListener(marker, 'click', () => {
          if (data.infoWindow) {
            data.infoWindow.close();
          }

          infowindow.open(data.map, marker);
          data.infoWindow = infowindow;
        });
      }
    }

    function centerMap(data) {
      var bounds = new google.maps.LatLngBounds();

      console.log(data)

      data.markers.forEach((marker) => {
        bounds.extend({
          lat: marker.position.lat(),
          lng: marker.position.lng()
        });
      });

      if (data.markers.length == 1) {
        data.map.setCenter( bounds.getCenter() );
      } else {
        data.map.fitBounds( bounds );
      }
    }

    //

    function onItemClick(e, data) {
      let $target = $(e.currentTarget);
      let index = $target.data('index');
      let markers = data.markers;
      let active;

      data.markers.forEach((marker) => {
        if ( index == marker.index ) {
          new google.maps.event.trigger( marker, 'click' );
        }
      });
    }

    //

    function init($el) {
      let data = {
        $el: $el,
        $items: $el.find('.js-map_item'),
        $map: $el.find('.js-community_poi_google_map'),
        $markers: $el.find('.js-map_marker').detach(),
        markers: [],
        infoWindow: null,
      };

      //

      let mapOptions = {
        zoom: $el.data('zoom') || 12,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        // disableDefaultUI: true,
        streetViewControl: false,
        mapTypeControl: false,
        fullscreenControl: false,
        styles: window.THEME_MAP_STYLES,
      };

      data.map = new google.maps.Map(data.$map[0], mapOptions);

      //

      data.$markers.each((index, el) => {
        initMarker($(el), data);
      });

      setDistances(data);

      // data.$items.each((index, el) => {
      //   initItem($(el), data);
      // });

      data.$el.on('click', '.js-map_item', (e) => {
        onItemClick(e, data);
      });

      centerMap(data);

      return data;
    }

    //

    $('.js-community_poi_map').each((index, el) => {
      let map = init($(el));
    });

  });